import { render, staticRenderFns } from "./SiteForumSingle.vue?vue&type=template&id=d894d588&"
import script from "./SiteForumSingle.vue?vue&type=script&lang=js&"
export * from "./SiteForumSingle.vue?vue&type=script&lang=js&"
import style0 from "./SiteForumSingle.vue?vue&type=style&index=0&id=d894d588&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports